function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { domain } from 'researcher';
import google from '../images/socialIcons/google.png';
import linkedIn from '../images/socialIcons/linkedIn.png';
import orcid from '../images/socialIcons/orcid.png';
import weChat from '../images/socialIcons/wechat.png';
import links from './links';
var service = domain.service;
var AJE = domain.service.AJE;
var adminServiceGroups = [{
  name: 'Reverse Translation (English to Chinese)',
  services: [AJE.REVERSE_TRANSLATION_ENGLISH_TO_CHINESE],
  serviceType: service.TYPE_EDITING
}, {
  name: 'Reverse Translation (English to Spanish)',
  services: [AJE.REVERSE_TRANSLATION_ENGLISH_TO_SPANISH],
  serviceType: service.TYPE_EDITING
}, {
  name: 'Reverse Translation (English to Portuguese)',
  services: [AJE.REVERSE_TRANSLATION_ENGLISH_TO_PORTUGUESE],
  serviceType: service.TYPE_EDITING
}, {
  name: 'Illustration',
  services: [AJE.ILLUSTRATION],
  serviceType: service.TYPE_FIGURES,
  identifier: service.ILLUSTRATION,
  optionsDeterminedByCount: true
}];
export default {
  website: {
    default: 'aje.com',
    cn: 'aje.cn'
  },
  chatBot: {
    meiqiaEnterpriseId: 'ed4a52590b24859c2d46954f405e1879'
  },
  consentBundle: {
    src: 'https://consent.cookiebot.com/uc.js',
    id: 'Cookiebot',
    data: {
      cbid: '7e71c262-8aa3-46d1-b980-6a7a634db06a',
      blockingmode: 'auto',
      georegions: "{'region':'US-06','cbid':'6c42d17e-c133-486f-bd70-1ce78cb7f328'},{'region':'BR','cbid':'3b2a7a6c-aacf-453c-afbf-ddb1dfacfe1f'},{'region':'ZA','cbid':'cff56831-8440-449c-adf3-abc5bd0c59bf'},{'region':'US-08','cbid':'6c42d17e-c133-486f-bd70-1ce78cb7f328'},{'region':'US-09','cbid':'868899bb-639d-41fc-936e-2d8b4d589d00'},{'region':'US-49','cbid':'8bd09cca-fa56-4520-a164-7e95d41318b9'},{'region':'US-51','cbid':'fd00c1b4-8f89-46f4-99df-57e282e9a162'}"
    }
  },
  orderFormVersion: '2022',
  authenticationProviders: [{
    id: 'google',
    icon: 'fa-brands fa-google',
    img: google,
    name: 'Google',
    supportedLanguages: ['en', 'br', 'es', 'jp'],
    supportedLocalizations: ['aje-row', 'aje-china']
  }, {
    id: 'linkedin',
    icon: 'fa-brands fa-linkedin',
    img: linkedIn,
    name: 'LinkedIn',
    supportedLanguages: ['cn', 'en', 'br', 'es', 'jp'],
    supportedLocalizations: ['aje-row']
  }, {
    id: 'orcid',
    icon: 'fa-solid fa-sign-in-alt',
    img: orcid,
    name: 'ORCID',
    supportedLanguages: ['cn', 'en', 'br', 'es', 'jp'],
    supportedLocalizations: ['aje-row', 'aje-china']
  }, {
    id: 'wechat',
    icon: 'fa-solid fa-sign-in-alt',
    img: weChat,
    name: 'weChat',
    supportedLanguages: ['cn', 'en', 'br', 'es', 'jp'],
    supportedLocalizations: ['aje-row', 'aje-china']
  }],
  displayReferralRewardsFlyer: true,
  displayPreprintCampaign: true,
  links: links,
  siteTitle: '%s  | AJE',
  reeditServiceMap: _defineProperty({
    editing: {
      identity: AJE.TOUCH_UP_EDITING,
      displaysDeadline: true,
      identifier: service.TOUCH_UP_EDITING
    },
    translation: {
      identity: AJE.TOUCH_UP_EDITING_FOR_TRANSLATION,
      displaysDeadline: true,
      identifier: service.TOUCH_UP_EDITING_FOR_TRANSLATION
    },
    formatting: {
      identity: AJE.TOUCH_UP_FORMATTING,
      defaultTimeline: 2,
      identifier: service.TOUCH_UP_FORMATTING
    }
  }, service.AUTOMATED_RE_EDITING, {
    identity: AJE.AUTOMATED_RE_EDITING,
    displaysDeadline: false,
    identifier: service.AUTOMATED_RE_EDITING
  }),
  fileAlertsForType: {
    manuscript: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, AJE.PREMIUM_CHINESE_TRANSLATION, 'manuscript-files-summary-references'), AJE.PREMIUM_SPANISH_TRANSLATION, 'manuscript-files-summary-references'), AJE.PREMIUM_JAPANESE_TRANSLATION, 'manuscript-files-summary-references'), AJE.SCIENTIFIC_EDITING, 'scientific-editing-file-upload-notice')
  },
  serviceGroups: [{
    name: 'Editing',
    services: [AJE.PREMIUM_EDITING, AJE.PREMIUM_ADVANCED_EDITING, AJE.ADVANCED_EDITING, AJE.STANDARD_EDITING],
    extendDeadlineWith: [AJE.FORMATTING, AJE.JOURNAL_REC],
    useAvailableServiceNameForSku: true,
    serviceType: service.TYPE_EDITING,
    excludesServices: [AJE.SCIENTIFIC_EDITING],
    delayServiceSelection: true
  }, {
    name: 'Translation',
    services: [AJE.PREMIUM_CHINESE_TRANSLATION, AJE.PREMIUM_JAPANESE_TRANSLATION, AJE.PREMIUM_SPANISH_TRANSLATION, AJE.STANDARD_PORTUGUESE_TRANSLATION, AJE.STANDARD_SPANISH_TRANSLATION],
    extendDeadlineWith: [AJE.FORMATTING, AJE.JOURNAL_REC],
    serviceType: service.TYPE_TRANSLATION,
    excludesServices: [AJE.SCIENTIFIC_EDITING],
    useAvailableServiceNameForSku: true,
    delayServiceSelection: true
  }, {
    name: 'formatting-service-tile',
    services: [AJE.FORMATTING],
    excludeDeadlineWithServiceIds: [AJE.PREMIUM_ADVANCED_EDITING, AJE.ADVANCED_EDITING, AJE.PREMIUM_CHINESE_TRANSLATION, AJE.PREMIUM_JAPANESE_TRANSLATION, AJE.PREMIUM_EDITING, AJE.REVERSE_TRANSLATION_ENGLISH_TO_CHINESE, AJE.REVERSE_TRANSLATION_ENGLISH_TO_PORTUGUESE, AJE.REVERSE_TRANSLATION_ENGLISH_TO_SPANISH, AJE.PREMIUM_SPANISH_TRANSLATION, AJE.STANDARD_EDITING],
    excludesServices: [AJE.SCIENTIFIC_EDITING, AJE.JOURNAL_REC],
    serviceType: service.TYPE_FORMATTING,
    identifier: service.FORMATTING,
    priceLabel: '%(price)s'
  }, {
    name: 'Figure Formatting',
    services: [AJE.FIGURE_FORMATTING],
    optionsDeterminedByCount: true,
    excludesServices: [AJE.SCIENTIFIC_EDITING, AJE.JOURNAL_REC],
    serviceType: service.TYPE_FIGURES,
    identifier: service.FIGURE_FORMATTING
  }, {
    name: 'Table Formatting',
    services: [AJE.TABLE_FORMATTING],
    optionsDeterminedByCount: true,
    excludesServices: [AJE.SCIENTIFIC_EDITING, AJE.JOURNAL_REC],
    serviceType: service.TYPE_FIGURES,
    identifier: service.TABLE_FORMATTING
  }, {
    name: 'Journal Recommendation',
    services: [AJE.JOURNAL_REC],
    moreInfo: 'JournalRecommendation',
    excludeDeadlineWithServiceIds: [AJE.PREMIUM_ADVANCED_EDITING, AJE.ADVANCED_EDITING, AJE.PREMIUM_CHINESE_TRANSLATION, AJE.PREMIUM_JAPANESE_TRANSLATION, AJE.PREMIUM_EDITING, AJE.REVERSE_TRANSLATION_ENGLISH_TO_CHINESE, AJE.REVERSE_TRANSLATION_ENGLISH_TO_PORTUGUESE, AJE.REVERSE_TRANSLATION_ENGLISH_TO_SPANISH, AJE.PREMIUM_SPANISH_TRANSLATION, AJE.STANDARD_EDITING],
    excludesServices: [AJE.FIGURE_FORMATTING, AJE.FORMATTING, AJE.SCIENTIFIC_EDITING, AJE.TABLE_FORMATTING],
    serviceType: service.TYPE_JOURNALREC,
    identifier: service.JOURNAL_REC,
    priceLabel: '%(price)s'
  }].concat(adminServiceGroups, [{
    brand: 'npgle',
    name: 'Scientific Editing',
    services: [AJE.SCIENTIFIC_EDITING],
    serviceType: service.TYPE_EDITING,
    excludesServices: [AJE.PREMIUM_ADVANCED_EDITING, AJE.ADVANCED_EDITING, AJE.PREMIUM_CHINESE_TRANSLATION, AJE.FIGURE_FORMATTING, AJE.FORMATTING, AJE.PREMIUM_JAPANESE_TRANSLATION, AJE.JOURNAL_REC, AJE.PREMIUM_EDITING, AJE.PREMIUM_SPANISH_TRANSLATION, AJE.TABLE_FORMATTING, AJE.STANDARD_EDITING],
    identifier: service.SCIENTIFIC_EDITING
  }]),
  siteLanguages: [{
    name: '中文',
    code: 'cn'
  }, {
    name: '日本語',
    code: 'jp'
  }, {
    name: 'English',
    code: 'en'
  }, {
    name: 'Português',
    code: 'br'
  }, {
    name: 'Español',
    code: 'es'
  }],
  subNavigation: [],
  upsells: {
    figures: true,
    formatting: false,
    journalRec: true
  },
  marketingEmailConfig: {
    url: 'https://cl.s11.exct.net/DEManager.aspx',
    action: 'add',
    clientID: '514010896',
    deKey: {
      development: 'AJE_WEBFORM',
      docker: 'AJE_WEBFORM',
      staging: 'AJE_WEBFORM',
      production: 'MDE_AJE_WEBFORM'
    },
    languages: {
      br: 'Portuguese',
      cn: 'Chinese Simplified',
      en: 'English',
      es: 'Spanish',
      jp: 'Japanese'
    },
    returnXML: '0'
  }
};